import { Link, useLocation } from "react-router-dom"
import { APP_ROUTES } from "../utils/constants"
import InfoModal from "./InfoModal"
import { useAuth } from "../lib/useAuth"
import { useState, useEffect } from "react"
import { BarsOutlined } from "@ant-design/icons"
import sidebarStore from "../store/sidebarStore"

const Sidebar = () => {
    const { user, isAuthenticated } = useAuth()
    const sidebarIsOpen = sidebarStore((state) => state.sidebarIsOpen)
    const useMouseHover = sidebarStore((state) => state.useMouseHover)
    const setSidebarIsOpen = sidebarStore((state) => state.setSidebarIsOpen)
    const collapseButtonOnClick = sidebarStore((state) => state.collapseButtonOnClick)
    const section = sidebarStore((state) => state.section)

    const location = useLocation()
    const path = location.pathname

    if (!isAuthenticated) {
        return null
    }

    return (
        <div
            onMouseEnter={() => {
                useMouseHover && setSidebarIsOpen(true)
            }}
            onMouseLeave={() => {
                useMouseHover && setSidebarIsOpen(false)
            }}
            className={`sidebar ${sidebarIsOpen ? "open" : "closed"}`}
        >
            <div className="sidebar-section">
                {/* <!-- Logo bar --> */}
                <div className="logo-bar flex">
                    <img className="logo-bar__img" src={`assets/img/${user?.company_name}.png`} alt="Company Logo" />
                    {sidebarIsOpen ? (
                        <h1 className="logo-bar__name pt-2 text-[25px]">{user?.company_name?.replace("-", " ")}</h1>
                    ) : null}
                </div>

                {section?.setSearchBar && sidebarIsOpen ? (
                    <span className="search-bar">
                        <label htmlFor="search">
                            <img src="assets/icons/magnifying-glass.svg" className="search-bar__icon" alt="Search" />
                        </label>
                        <input
                            onChange={section.setSearchBar}
                            id="search"
                            type="text"
                            placeholder="جستجو ..."
                            className="search-bar__input"
                        />
                    </span>
                ) : null}

                {sidebarIsOpen ? <span className="sidebar-section__title">داشبورد</span> : null}
                <div className="sidebar-section__list">
                    {user?.can_use_servers ? (
                        <Link to={APP_ROUTES.INDEX}>
                            <span className={`sidebar-section__item${APP_ROUTES.INDEX === path ? " active" : ""}`}>
                                <img src="assets/icons/server.svg" className="sidebar-section__icon" alt="Servers" />
                                {sidebarIsOpen && <div className="sidebar-section__item-name">سرور های شما</div>}
                            </span>
                        </Link>
                    ) : null}

                    {user?.can_use_bot ? (
                        <Link to={APP_ROUTES.MUSIC_BOTS}>
                            <div className={`sidebar-section__item${APP_ROUTES.MUSIC_BOTS === path ? " active" : ""}`}>
                                <img src="assets/icons/music.svg" className="sidebar-section__icon" alt="Music Bots" />
                                {sidebarIsOpen && <div className="sidebar-section__item-name"> ربات های موزیک </div>}
                            </div>
                        </Link>
                    ) : null}

                    {user?.can_use_manager_bots ? (
                        <Link to={APP_ROUTES.TS_MANAGER_BOTS}>
                            <span
                                className={`sidebar-section__item${APP_ROUTES.TS_MANAGER_BOTS === path ? " active" : ""}`}
                            >
                                <img
                                    src="assets/icons/robot.svg"
                                    className="sidebar-section__icon"
                                    alt="Manager Bots"
                                />
                                {sidebarIsOpen && <div className="sidebar-section__item-name"> ربات های مدیریتی </div>}
                            </span>
                        </Link>
                    ) : null}

                    {user?.can_use_ranksystems ? (
                        <Link to={APP_ROUTES.RANKSYSTEMS}>
                            <span
                                className={`sidebar-section__item${APP_ROUTES.RANKSYSTEMS === path ? " active" : ""}`}
                            >
                                <img
                                    src="assets/icons/robot.svg"
                                    className="sidebar-section__icon"
                                    alt="Rank Systems"
                                />
                                {sidebarIsOpen && (
                                    <div className="sidebar-section__item-name"> ربات های رنک سیستم </div>
                                )}
                            </span>
                        </Link>
                    ) : null}

                    {user?.can_use_banner ? (
                        <Link to={APP_ROUTES.BANNER_BOTS}>
                            <span
                                className={`sidebar-section__item${APP_ROUTES.BANNER_BOTS === path ? " active" : ""}`}
                            >
                                <img
                                    src="assets/icons/image-outline.svg"
                                    className="sidebar-section__icon text-white"
                                    alt="Banner Bots"
                                />
                                {sidebarIsOpen && <div className="sidebar-section__item-name"> ربات بنر داینامیک</div>}
                            </span>
                        </Link>
                    ) : null}

                    {user && user.scope === "admin" ? (
                        <Link to={APP_ROUTES.USERS}>
                            <span className={`sidebar-section__item${APP_ROUTES.USERS === path ? " active" : ""}`}>
                                <img src="assets/icons/users.svg" className="sidebar-section__icon" alt="Users" />
                                {sidebarIsOpen && <div className="sidebar-section__item-name">کاربران پنل</div>}
                            </span>
                        </Link>
                    ) : null}
                </div>
            </div>
            {section ? (
                <div className="sidebar-section">
                    {sidebarIsOpen ? <span className="sidebar-section__title">{section.title}</span> : null}
                    <div className="sidebar-section__list">
                        {section.buttons.map((item, index) => (
                            <span
                                key={index}
                                onClick={item.onClick}
                                className={`sidebar-section__item sidebar-section__item--${item.color}`}
                            >
                                <img
                                    src={`assets/icons/${item.iconName}.svg`}
                                    className="sidebar-section__icon"
                                    alt={item.name}
                                />
                                {sidebarIsOpen && (
                                    <button className="sidebar-section__item-name outline-none">{item.name}</button>
                                )}
                            </span>
                        ))}
                    </div>
                </div>
            ) : null}

            <div className="sidebar-section">
                <div className="sidebar-section__list">
                    <a href="https://www.aparat.com/Nedxco.IR" target="_blank" rel="noopener noreferrer">
                        <span className="sidebar-section__item">
                            <img
                                src="assets/icons/graduation-cap.svg"
                                className="sidebar-section__icon"
                                alt="Education"
                            />
                            {sidebarIsOpen && <span className="sidebar-section__item-name">آموزش</span>}
                        </span>
                    </a>
                    <InfoModal user={user} sidebarIsOpen={sidebarIsOpen} />
                    <Link to={APP_ROUTES.SETTINGS}>
                        <span className={`sidebar-section__item${APP_ROUTES.SETTINGS === path ? " active" : ""}`}>
                            <img src="assets/icons/gear-complex.svg" className="sidebar-section__icon" alt="Settings" />
                            {sidebarIsOpen && "تنظیمات"}
                        </span>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
